import * as React from "react";
import { useAppState } from "../state";
import styled from "styled-components";

const Logo = styled.img`
  max-height: 70px;
  padding: 7px 0;
  margin-top: 5px;
  @media only screen and (max-width: 1240px) {
    padding: 7px 0;
    max-height: 45px;
    margin-top: 20px;
  }
`;

export const HeaderLogoComponent = React.memo(function HeaderLogoComponent() {
  const { tenantConfig } = useAppState();

  if (!tenantConfig) {
    return null;
  }

  return (
    <a
      href={tenantConfig?.get("logoUrl") || "#"}
      target={tenantConfig?.get("logoUrl") ? "_blank" : undefined}
      rel={tenantConfig?.get("logoUrl") ? "noopener noreferrer" : undefined}
      aria-label={tenantConfig?.get("title") || "Logo"}
    >
      <Logo
        alt={tenantConfig?.get("title") || "Logo"}
        style={{
          height: "100%",
          float: "right",
        }}
        src={tenantConfig?.get("logo")?.url() || ""}
      />
    </a>
  );
});
